export const EmbedModes = {
  STANDARD: "standard",
  FULL_PAGE: "fullpage",
  POPUP: "popup",
  SLIDER: "slider",
  POPOVER: "popover",
  SIDE_TAB: "sidetab"
};
